import styled from 'styled-components';
import { colors } from '../../style/colors';
import { H1 } from '../../style/typography';
import { icons } from '../../style/icons';
import { min } from '../../lib/responsive';

const HomeLandingText = styled(H1)`
  color: ${colors.YELLOW};
  font-size: 2.5em;
  width: 6em;
  line-height: 0.8em;

  @media ${min.tabletSm} {
    width: 6.5em;
    font-size: 3.5em;
    padding-bottom: 0.5em;
  }

  @media ${min.tablet} {
    font-size: 4.5em;
    width: 5em;
  }
`;

const HomeLandingContainer = styled.div`
  display: flex;
  align-items: flex-end;
  background-image: url(${icons.HOME_PAGE_LANDING.image});
  background-size: 340%;
  width: 100%;
  background-position: 20% 55%;
  height: 40em;
  position: absolute;
  top: 0;
  z-index: 6;
  @media ${min.tabletSm} {
    background-size: 250%;
  }

  @media ${min.tablet} {
    background-size: 175%;
    height: 46em;
  }

  @media ${min.tabletLg} {
    background-size: 125%;
  }

  @media ${min.desktop} {
    background-size: 100%;
  }
`;

export { HomeLandingContainer, HomeLandingText };
